var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-device-desktop-analytics",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20h10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16v4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16v4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12v-4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12v-1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12v-2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12v-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.556baf1c895448e60cf1dcbae1e1df3a.svg";
export { ForwardRef as ReactComponent };